// Mounts public commercial search and the authenticated sales database view.
import { createApp } from 'vue';

import Filters from '../components/general/filters.vue';
import PropertiesContainer from '../components/properties/properties-container.vue';
import getWindowSize from '../helpers/getWindowSize';

const propertiesElement = document.getElementById('properties-container');

if (propertiesElement) {
    const logoutUrl = propertiesElement.getAttribute('data-logout-url') || null;
    const propertiesApp = createApp({
        components: { PropertiesContainer },
        template: `
            <PropertiesContainer
                :window-size="windowSize"
                :logout-url="logoutUrl"
            />
        `,
        data() {
            return {
                windowSize: getWindowSize(),
                logoutUrl,
            };
        },
        mounted() {
            window.addEventListener('resize', this.updateWindowSize);
        },
        beforeUnmount() {
            window.removeEventListener('resize', this.updateWindowSize);
        },
        methods: {
            updateWindowSize() {
                this.windowSize = getWindowSize();
            },
        },
    });

    propertiesApp.config.compilerOptions.whitespace = 'preserve';
    propertiesApp.component('filters', Filters);
    propertiesApp.mount(propertiesElement);
}

const footerElement = document.getElementById('footer-cta');
if (footerElement) {
    const footerApp = createApp({});
    footerApp.config.compilerOptions.whitespace = 'preserve';
    footerApp.component('filters', Filters);
    footerApp.mount(footerElement);
}
